import { TeamListPage, TeamEditPage, TeamCreatePage } from './imports';

export const teamRoutes = [
  {
    path: 'teams',
    children: [
      {
        element: <TeamListPage />,
        index: true,
      },
      {
        path: 'list',
        element: <TeamListPage />,
      },
      {
        path: ':id/edit',
        element: <TeamEditPage />,
      },
      {
        path: 'new',
        element: <TeamCreatePage />,
      },
    ],
  },
];
